// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__23yEr","modal":"Modal_modal__jxzI2","slide-down":"Modal_slide-down__1jtEN"};